import flagKeys from '@/constants/flagKeys';
import Redemptions from '@/views/Performance/Redemptions.vue';

import { Route } from '../../route.model';

const conversions = new Route(
  '/performance/conversions',
  'performance-conversions',
  Redemptions,
  {
    requiresAuth: true,
    isResponsive: true,
    flag: flagKeys.merchantDashboardReports,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Conversions',
      icon: 'conversions',
      description:
        'List of every conversion-related event that your Loyalty Rewards Program has generated.'
    },
    pageView: {
      eventLabel: 'Conversions'
    }
  }
);

export { conversions };
export default conversions;
